export default __webpack_public_path__ + "static/media/ZoomOut.09e30286.svg";